import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { ButtonModule } from '../common/button/button.module';
import { GroupModule } from '../common/group/group.module';
import { IconModule } from '../common/icon/icon.module';
import { InputModule } from '../forms/input/input.module';
import { CopyInputComponent } from './copy-input/copy-input.component';
import { CopyTextDropdownComponent } from './copy-text-dropdown/copy-text-dropdown.component';
import { ClickToCopyDirective } from './directives/click-to-copy.directive';

@NgModule({
  imports: [CommonModule, GroupModule, InputModule, I18nModule, IconModule, ButtonModule],
  declarations: [CopyInputComponent, CopyTextDropdownComponent, ClickToCopyDirective],
  exports: [CopyInputComponent, CopyTextDropdownComponent, ClickToCopyDirective],
})
export class RtCopyTextModule {}
export { CopyInputComponent, CopyTextDropdownComponent, ClickToCopyDirective };
